import React from 'react';

const common = require('../common/common');
const env = require("../../config.js").default;

class FilterVM extends React.Component{
  constructor(props){
		super(props);
    this.state = {};
    this.state.actualVM = null
    this.state.folder = this.props.folder
    this.state.marche_attive = this.props.marche_attive;
    this.state.tableType = this.props.tableType !== undefined ? this.props.tableType : '';
    this.tipologie_ticket_attive = common.getTicketTypesByBrand();
  }

  componentDidMount(){
    const $ = window.$;
    if((this.state.tableType === 'ticket' && !window.cc.ticketFirebird)){
      var new_marche_attive = [];
      var marcheAttive = this.state.marche_attive;
      for (var i = 0; i < marcheAttive.length; i++) {
        if(this.tipologie_ticket_attive[marcheAttive[i].ZFORN] !== undefined)
          new_marche_attive.push(marcheAttive[i]);
      }
      this.setState({marche_attive: new_marche_attive})
    }

    function format(state) {
      if (!state.id || state.id === 'tutti_modelli') return state.text; // optgroup
      return '<img style="height: 30px;" title="' + state.text +'" src="' + env.SWAN + 'static/images/loghi/' + state.id.toLowerCase() + '.png"/>'; // optgroup
    }

    if(this.props.folder === 'ticket'){
      if(this.props.newTicket){
        $("#select_vm").append('<option value="">' + common.getTrad("Tutte le marche") + '</option>').select2({
          templateResult: format,
          templateSelection: format,
          escapeMarkup: function (m) { return m; },
          language: common.getLanguage(),
          placeholder: common.getTrad("Seleziona una marca"),
          dropdownParent: $('#content_page')
        });
      }else{
        $("#select_vm").append('<option value="">' + common.getTrad("Tutte le marche") + '</option>').select2({
          templateResult: format,
          templateSelection: format,
          escapeMarkup: function(m) { return m; },
          language: common.getLanguage(),
          placeholder: common.getTrad("Seleziona una marca"),
          dropdownParent:  $('#collapseFiltri')
        });
      }
    }else{
      $("#select_vm").append('<option value="">' + common.getTrad("Tutte le marche") + '</option>').select2({
        templateResult: format,
        templateSelection: format,
        escapeMarkup: function (m) { return m; },
        language: common.getLanguage(),
        placeholder: common.getTrad("Seleziona una marca"),
      });      
    }

    $('#select_vm').on('select2:select keyup select2:unselect', (e) => {
      e.preventDefault();
			var marca = '';
      common.set_localStorage("valoreModello", '');
      if ((!window.cc.ticketFirebird && !this.state.isTable) || (window.cc.ticketFirebird && !this.props.isTable) || (window.cc.ticketFirebird && this.props.tableType == 'default')) {
        if(e.target.value === '' || e.target.value === 'tutti_modelli'){
          marca = "";
          $('#EDTNTELA').val('');
          if(this.state.tableType !== 'ticket' && this.state.tableType !== 'ticket_vehicle') {
            $('.select_modelli').empty("<option value='tutti_modelli'>"+ common.getTrad("Seleziona un modello") + "</option>").select2({placeholder: common.getTrad("Seleziona prima una marca")});
            common.set_localStorage("valoreMarca", '');
            common.set_localStorage("valoreVIN", '');
          }else{
            common.set_localStorage("filtriTicketsTipologie", '');
            $('.tipologieTicket').empty("<option value='tutti_modelli'>"+ common.getTrad("Seleziona un tipo") + "</option>").select2({placeholder: common.getTrad("Seleziona un tipo")});
            var tipologia_ticket = "";
            common.remove_localStorage('valoreTipologiaTicket');
          }
        }else{
          if(this.state.tableType !== 'ticket' && this.state.tableType !== 'ticket_vehicle') {
            common.set_localStorage("valoreMarca", e.target.value);
          }
          common.set_localStorage("filtriTicketsTipologie", '');
          marca = e.target.value;
        }
      }
      
			var parametri = {
				filtro_marca: marca,
        tipologia_ticket: tipologia_ticket,
			}
      this.props.onClick("filtro_marca", parametri, this.state.tableType.indexOf('ticket') > -1 ? false : true);
			return false;
		});

    if(this.props.tableType === 'content'|| this.props.tableType === 'default'){
      if (common.get_localStorage("valoreMarca") !== undefined && common.get_localStorage("valoreMarca") !== null && common.get_localStorage("valoreMarca") !== '') {
        $("select#select_vm").val(common.get_localStorage("valoreMarca")).trigger("change");
        }
    }else{
      if ((this.props.isTable && this.state.tableType === 'ticket') || (this.props.isTable && this.state.tableType === 'ticket_vehicle'))
      this.updateIndexedDB()
    }
   
  }

  changeFilterHandler = () => {
    const $ = window.$;
    this.props.sendData(this.state.actualVM);
  }

  updateIndexedDB() {
    //imposta il primo valore se l'indexedDB è popolato
    const $ = window.$;
    common.get_UX_component(this.state.folder, "Filters", "Vm_filter").then((marca) => {
      if (marca !== undefined && marca !== '') {
        this.setState({ actualVM: marca }, () => {
          this.changeFilterHandler();
          window.setTimeout(() => {
            $('#select_vm').val(marca).trigger("change");
          }, 400);
          if (this.state.actualVM !== null) {
            $('#vmDot').css('visibility', 'visible');
          } else if (this.state.actualVM === null) {
            $('#vmDot').css('visibility', 'hidden');
          }
        });
      }
    })
  }

  componentDidUpdate(){
    const $ = window.$;
    function format(state) {
      if (!state.id || state.id === 'tutti_modelli') return state.text; // optgroup
      return '<img style="height: 30px;" title="' + state.text + '" src="' + env.SWAN + 'static/images/loghi/' + state.id.toLowerCase() + '.png"/>'; // optgroup
    }
    if ((window.cc.ticketFirebird && this.props.isTable && this.state.tableType === 'ticket') || (window.cc.ticketFirebird && this.props.isTable && this.state.tableType === 'ticket_vehicle')) {
      $('#select_vm').on('select2:select', (e) => {
        if ($('#select_vm').val() === '' || $('#select_vm').val() === 'tutti_modelli') {
          this.state.actualVM = null
        }else{       
          this.state.actualVM = $('#select_vm').val()
        }
        this.changeFilterHandler();

        if (this.state.actualVM !== null) {
          $('#vmDot').css('visibility', 'visible');
        } else if (this.state.actualVM === null) {
          $('#vmDot').css('visibility', 'hidden');
        }
      })
    }
    if (this.props.newTicket) {
      $(document).ready(function () {
        $("#select_vm").select2({
          templateResult: format,
          templateSelection: format,
          escapeMarkup: function (m) { return m; },
          language: common.getLanguage(),
          placeholder: common.getTrad("Seleziona una marca"),
          dropdownParent: $("#content_page")
        });
      });
    }
  }

  render(props){
  	return(
      <div className={(this.props.customClass !== undefined ? this.props.customClass : "col-xl-6 col-lg-6") +  " col-md-12 col-sm-12 col-xs-12 row-eq-height"} role="alert" id="ricerca_filtro_modello">
        <div className="col-12 p-0">
          <p>{common.getTrad("Filtra per casa costruttrice")} <span id="vmDot" className="orange-dot" style={{ visibility: 'hidden', position: 'absolute', left: '-9px', top: '7px' }}></span></p>
          <div className="form-group selectSwCustom">
            <select name="select_vm" className="form-control select_marche" id="select_vm">
              <option value="tutti_modelli">{common.getTrad("Tutte le marche")}</option>
              {this.state.marche_attive.map((item, key) => {
                return (
                  <option key={key} value={item.ZFORN}>{item.DFORN}</option>
                )
              })}
            </select>
          </div>
        </div>
      </div>
     )
  }
}

export default FilterVM;
